var PromptEvent = {}

//增加一个提示数据
PromptEvent.ADD_PROMPT_DATA = "PromptEvent.ADD_PROMPT_DATA";

//减少一个提示数据
PromptEvent.REMOVE_PROMPT_DATA = "PromptEvent.REMOVE_PROMPT_DATA";

module.exports = PromptEvent